import { useEffect, useState, useCallback } from "react";
import i18next from "i18next";
import TimeDropdown30Min from "components/atoms/TimeDropdown30Min/TimeDropdown30Min";

export default function TimePickerRedux30Min({
  input,
  label,
  InputProps,
  handleBlur,
  handleFocus,
  TimePickerProps,
  meta: { error, touched, invalid },
  ...rest
}: any) {
  const { onChange, ...inputRest } = input;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setDropdownOpen(true);
    TimePickerProps?.onOpen?.();
  }, [TimePickerProps]);

  const handleClose = useCallback(() => {
    setDropdownOpen(false);
    TimePickerProps?.onClose?.();
  }, [TimePickerProps]);

  const [cError, setCError] = useState(i18next.t(`${error}`));
  const [currentLanguage, setCurrentLanguage] = useState(i18next.language);

  useEffect(() => {
    if (currentLanguage !== i18next.language) {
      setCurrentLanguage(i18next.language);
    }
  }, [currentLanguage]);

  useEffect(() => {
    setCError(i18next.t(`${error}`));
  }, [error, currentLanguage]);

  return (
    <TimeDropdown30Min
      {...TimePickerProps}
      {...rest}
      onChange={onChange}
      value={input.value} // Bind Redux-form's value
      onOpen={handleOpen}
      onClose={handleClose}
      onSelectionComplete={
        TimePickerProps?.onSelectionComplete ?? rest.onSelectionComplete
      }
      InputFieldProps={{
        ...TimePickerProps?.InputFieldProps,
        ...InputProps,
        ...inputRest,
        label,
        helperText: touched && invalid && cError,
        error: touched && invalid && error && true,
      }}
      onAutoCorrect={rest.onAutoCorrect} // ADD THIS
    />
  );
}
